var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragIndicator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25,17c-1.375,0-2.5,1.125-2.5,2.5S6.875,22,8.25,22s2.5-1.125,2.5-2.5S9.625,17,8.25,17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75,7c1.375,0,2.5-1.125,2.5-2.5S17.125,2,15.75,2s-2.5,1.125-2.5,2.5S14.375,7,15.75,7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25,9.5c-1.375,0-2.5,1.125-2.5,2.5s1.125,2.5,2.5,2.5s2.5-1.125,2.5-2.5S9.625,9.5,8.25,9.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25,2c-1.375,0-2.5,1.125-2.5,2.5S6.875,7,8.25,7s2.5-1.125,2.5-2.5S9.625,2,8.25,2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75,17c-1.375,0-2.5,1.125-2.5,2.5s1.125,2.5,2.5,2.5s2.5-1.125,2.5-2.5S17.125,17,15.75,17z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75,9.5c-1.375,0-2.5,1.125-2.5,2.5s1.125,2.5,2.5,2.5s2.5-1.125,2.5-2.5S17.125,9.5,15.75,9.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIndicator);
export default __webpack_public_path__ + "static/media/drag-indicator.424fffa6dc2ee877fa2c597b92b2aa18.svg";
export { ForwardRef as ReactComponent };